var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnDashboardSwitchOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03526 17.0588C7.38285 16.4071 8.06134 16 8.79997 16H51.2C51.9386 16 52.6171 16.4071 52.9647 17.0588L59.6313 29.5588C59.7858 29.8485 59.8666 30.1717 59.8666 30.5V42C59.8666 43.1046 58.9712 44 57.8666 44H2.1333C1.02873 44 0.133301 43.1046 0.133301 42V30.5C0.133301 30.1717 0.214109 29.8485 0.368595 29.5588L7.03526 17.0588Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2074 29.0669H1.79256C0.876177 29.0669 0.133301 29.7355 0.133301 30.5602V42.5069C0.133301 43.3316 0.876177 44.0002 1.79256 44.0002H58.2074C59.1238 44.0002 59.8666 43.3316 59.8666 42.5069V30.5602C59.8666 29.7355 59.1238 29.0669 58.2074 29.0669Z",
    fill: "url(#paint0_linear_2335_50966)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5062 32.7998H19.7333V35.5659H22.5062V32.7998Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5062 38.3315H19.7333V41.0976H22.5062V38.3315Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6657 32.7998H23.8928V35.5659H26.6657V32.7998Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6657 38.3315H23.8928V41.0976H26.6657V38.3315Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8252 32.7998H28.0522V35.5659H30.8252V32.7998Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9857 32.7998H32.2128V35.5659H34.9857V32.7998Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8252 38.3315H28.0522V41.0976H30.8252V38.3315Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9857 38.3315H32.2128V41.0976H34.9857V38.3315Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1063 32.7998H39.3334V35.5659H42.1063V32.7998Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1063 38.3315H39.3334V41.0976H42.1063V38.3315Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2657 32.7998H43.4928V35.5659H46.2657V32.7998Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2657 38.3315H43.4928V41.0976H46.2657V38.3315Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4251 32.7998H47.6522V35.5659H50.4251V32.7998Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5857 32.7998H51.8127V35.5659H54.5857V32.7998Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4251 38.3315H47.6522V41.0976H50.4251V38.3315Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5857 38.3999H51.8127V41.166H54.5857V38.3999Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43335 32.7998H4.10002C3.45568 32.7998 2.93335 33.4266 2.93335 34.1998C2.93335 34.973 3.45568 35.5998 4.10002 35.5998H6.43335C7.07768 35.5998 7.60002 34.973 7.60002 34.1998C7.60002 33.4266 7.07768 32.7998 6.43335 32.7998Z",
    fill: "#C5C5C5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2335_50966",
    x1: 30,
    y1: 29.0669,
    x2: 30,
    y2: 44.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDashboardSwitchOff);
export default __webpack_public_path__ + "static/media/icn_dashboard_switch_off.f351d290561793437da7d44d4e73e2d4.svg";
export { ForwardRef as ReactComponent };